export type FloorPlanCatalogGroup = 'furniture' | 'kitchen' | 'bath' | 'shop' | 'vehicles' | 'marks' | 'stairs';

export interface FloorPlanCatalogEntry {
  id: string;
  label: string;
  group: FloorPlanCatalogGroup;
  widthIn: number;
  depthIn: number;
}

export const FLOOR_PLAN_CATALOG: FloorPlanCatalogEntry[] = [
  { id: 'sofa', label: 'Sofa', group: 'furniture', widthIn: 84, depthIn: 36 },
  { id: 'loveseat', label: 'Loveseat', group: 'furniture', widthIn: 60, depthIn: 36 },
  { id: 'armchair', label: 'Armchair', group: 'furniture', widthIn: 36, depthIn: 36 },
  { id: 'dining-table', label: 'Dining table', group: 'furniture', widthIn: 72, depthIn: 42 },
  { id: 'coffee-table', label: 'Coffee table', group: 'furniture', widthIn: 48, depthIn: 24 },
  { id: 'bed-queen', label: 'Queen bed', group: 'furniture', widthIn: 80, depthIn: 60 },
  { id: 'bed-king', label: 'King bed', group: 'furniture', widthIn: 80, depthIn: 76 },
  { id: 'nightstand', label: 'Nightstand', group: 'furniture', widthIn: 24, depthIn: 16 },
  { id: 'desk', label: 'Desk', group: 'furniture', widthIn: 60, depthIn: 30 },
  { id: 'fridge', label: 'Fridge', group: 'kitchen', widthIn: 36, depthIn: 30 },
  { id: 'range', label: 'Range', group: 'kitchen', widthIn: 30, depthIn: 27 },
  { id: 'sink', label: 'Sink', group: 'kitchen', widthIn: 36, depthIn: 24 },
  { id: 'dishwasher', label: 'Dishwasher', group: 'kitchen', widthIn: 24, depthIn: 24 },
  { id: 'island', label: 'Island', group: 'kitchen', widthIn: 72, depthIn: 36 },
  { id: 'base-cabinet', label: 'Base cabinet', group: 'kitchen', widthIn: 36, depthIn: 24 },
  { id: 'toilet', label: 'Toilet', group: 'bath', widthIn: 28, depthIn: 20 },
  { id: 'vanity', label: 'Vanity', group: 'bath', widthIn: 36, depthIn: 21 },
  { id: 'tub', label: 'Tub', group: 'bath', widthIn: 60, depthIn: 32 },
  { id: 'shower', label: 'Shower', group: 'bath', widthIn: 36, depthIn: 36 },
  { id: 'welder', label: 'Welder', group: 'shop', widthIn: 30, depthIn: 22 },
  { id: 'plasma-table', label: 'Plasma table', group: 'shop', widthIn: 120, depthIn: 60 },
  { id: 'welding-table', label: 'Welding table', group: 'shop', widthIn: 60, depthIn: 36 },
  { id: 'compressor', label: 'Compressor', group: 'shop', widthIn: 42, depthIn: 20 },
  { id: 'shop-cabinet-24', label: 'Cabinet 24"', group: 'shop', widthIn: 24, depthIn: 24 },
  { id: 'shop-cabinet-36', label: 'Cabinet 36"', group: 'shop', widthIn: 36, depthIn: 24 },
  { id: 'shop-cabinet-48', label: 'Cabinet 48"', group: 'shop', widthIn: 48, depthIn: 24 },
  { id: 'tool-chest', label: 'Tool chest', group: 'shop', widthIn: 42, depthIn: 24 },
  { id: 'flammable-cabinet', label: 'Flammable cabinet', group: 'shop', widthIn: 34, depthIn: 18 },
  { id: 'workbench', label: 'Workbench', group: 'shop', widthIn: 96, depthIn: 30 },
  { id: 'table-saw', label: 'Table saw', group: 'shop', widthIn: 48, depthIn: 36 },
  { id: 'band-saw', label: 'Band saw', group: 'shop', widthIn: 36, depthIn: 30 },
  { id: 'miter-saw', label: 'Miter saw', group: 'shop', widthIn: 72, depthIn: 30 },
  { id: 'drill-press', label: 'Drill press', group: 'shop', widthIn: 24, depthIn: 24 },
  { id: 'planer', label: 'Planer', group: 'shop', widthIn: 40, depthIn: 30 },
  { id: 'dust-collector', label: 'Dust collector', group: 'shop', widthIn: 36, depthIn: 36 },
  { id: 'cnc-router', label: 'CNC router', group: 'shop', widthIn: 96, depthIn: 48 },
  { id: 'lumber-rack', label: 'Lumber rack', group: 'shop', widthIn: 144, depthIn: 36 },
  { id: 'pallet', label: 'Pallet', group: 'shop', widthIn: 48, depthIn: 40 },
  { id: 'gas-cylinders', label: 'Gas cylinders', group: 'shop', widthIn: 30, depthIn: 20 },
  { id: 'car', label: 'Car', group: 'vehicles', widthIn: 180, depthIn: 72 },
  { id: 'suv', label: 'SUV', group: 'vehicles', widthIn: 192, depthIn: 78 },
  { id: 'pickup', label: 'Pickup', group: 'vehicles', widthIn: 228, depthIn: 80 },
  { id: 'van', label: 'Cargo van', group: 'vehicles', widthIn: 240, depthIn: 84 },
  { id: 'box-truck', label: 'Box truck', group: 'vehicles', widthIn: 312, depthIn: 96 },
  { id: 'flatbed', label: 'Flatbed', group: 'vehicles', widthIn: 336, depthIn: 102 },
  { id: 'dump-truck', label: 'Dump truck', group: 'vehicles', widthIn: 300, depthIn: 96 },
  { id: 'crane-truck', label: 'Crane truck', group: 'vehicles', widthIn: 420, depthIn: 108 },
  { id: 'forklift', label: 'Forklift', group: 'vehicles', widthIn: 96, depthIn: 48 },
  { id: 'trailer', label: 'Trailer', group: 'vehicles', widthIn: 240, depthIn: 96 },
  { id: 'north-arrow', label: 'North arrow', group: 'marks', widthIn: 36, depthIn: 36 },
  { id: 'stair-straight', label: 'Straight run', group: 'stairs', widthIn: 36, depthIn: 140 },
  { id: 'stair-l', label: 'L with landing', group: 'stairs', widthIn: 120, depthIn: 120 },
  { id: 'stair-u', label: 'U with landing', group: 'stairs', widthIn: 84, depthIn: 140 },
  { id: 'stair-spiral', label: 'Spiral', group: 'stairs', widthIn: 60, depthIn: 60 },
];

export const FLOOR_PLAN_CATALOG_GROUPS: { id: FloorPlanCatalogGroup; label: string }[] = [
  { id: 'furniture', label: 'Furniture' },
  { id: 'kitchen', label: 'Kitchen' },
  { id: 'bath', label: 'Bath' },
  { id: 'shop', label: 'Shop' },
  { id: 'vehicles', label: 'Vehicles' },
];

export function catalogEntry(id: string): FloorPlanCatalogEntry | undefined {
  return FLOOR_PLAN_CATALOG.find((item) => item.id === id);
}

export const DEFAULT_OPENING_WIDTH_IN: Record<'door' | 'window' | 'garage_door', number> = {
  door: 36,
  window: 36,
  garage_door: 108,
};
